import { takeLatest, call, put } from 'redux-saga/effects'
import * as fromActions from '../../actions/courses.action'
import getCoursesCounters from 'api/courses/Counters'

async function getCounters() {
  return await getCoursesCounters()
}

function* courseGetCountersEffectSaga() {
  try {
    const data = yield call(getCounters)
    yield put(fromActions.Actions.coursesGetCountersSuccess(data))
  } catch (error) {
    console.log('error: ', error)
  }
}

export function* coursegetCountersWatcherSaga() {
  yield takeLatest(fromActions.COURSES_GET_COUNTERS, courseGetCountersEffectSaga)
}
